<template>
  <div>
    <div class="content-wizard">
      <div class="row">
        <div v-if="false"
             class="col-lg-12">
          <div class="alert alert-danger">
            <span class="alert-link">Attention</span> : si Marc BRANDELET (propriétaire actuel) n’est pas présent, il devra faire une procuration à une personne présente.
          </div>
        </div>
        <div class="col-lg-12 border-bottom"
             style="margin-top: -20px;">
          <div class="row-flex">
            <div class="col-lg-2 text-center">
            </div>
            <div v-for="(date, index) in sortedSaleRdvProposalDate"
                 :key="index"
                 class="col-lg-2 text-center date">
              <div v-html="formatDateFull(date.date)"/>
              <a class="date-cancel"
                 @click="deleteSaleRdvProposalDate(date.id)">
                <i class="fa fa-times"></i>
              </a>
            </div>
            <div class="col-lg-2 text-center m-t-sm"
                 style="align-items: center;">
              <span>
                Ajouter un créneau
              </span>
              <button class="btn btn-primary btn-circle mt10 mb10"
                      @click="onClickNewDate"><i class="fa fa-plus"></i>
              </button>
            </div>
          </div>
        </div>
        <datetime input-id="datetime-picker"
                  input-class="hidden"
                  v-model="date"
                  type="datetime"
                  :minute-step="30"
                  class="datepicker-theme"></datetime>
        <div v-for="(participant, index) in saleRdvParticipant"
             :key="index"
             class="col-lg-12 someone"
             :class="{'bg-white': !(index % 2)}">
          <div class="row-flex">
            <div class="col-lg-2">
              <p>
                <span class="font-bold">{{ participant.title }}</span>
                <br>
                {{ participant.name }}
              </p>
              <a class="participant-cancel"
                 @click="deleteParticipant(participant.id)">
                <i class="fa fa-times"></i>
              </a>
            </div>
            <div v-for="item in saleRdvProposalDate"
                 :key="item.id"
                 class="col-lg-2 text-center">
              <div class="i-checks">
                <label>
                  <input type="checkbox"
                         :checked="availableSaleRdv(participant.id, item.id)"
                         @change="e => onChange(e, participant.id, item.id)">
                </label>
              </div>
            </div>
            <div class="col-lg-2">
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="row">
            <div class="m-t">
              <div class="col-lg-2 text-center m-b-sm">
                <button class="btn btn-primary btn-circle"
                        @click="onClickNewParticipant">
                  <i class="fa fa-plus"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12 bg-white"
             style="height: 50px;">
          <div class="row-flex"
               style="margin-top: 15px;">
            <div class="col-lg-2">
              <p class=""><span class="font-bold">Rdv de cession</span></p>
            </div>
            <div v-for="(item, index) in sortedSaleRdvProposalDate"
                 :key="index"
                 class="col-lg-2 text-center">
              <div class="i-checks">
                <label>
                  <input v-if="areAllSelected(item.id)"
                         type="radio"
                         :checked="finalDate === item.date"
                         :value="item.date"
                         v-model="finalDate">
                </label>
              </div>
            </div>
            <div class="col-lg-2"/>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="m-t-xl">
            <label class="control-label">Commentaire</label>
            <textarea rows="3"
                      cols="50"
                      style="width:100%"
                      v-model="comment"></textarea>
          </div>
        </div>
      </div>

    </div>
    <div class="row">
      <div class="col-lg-12">
        <button type="button"
                class="pull-left btn btn-w-m btn-primary pull-right"
                @click="$parent.toggleBlock(1)">Précédent</button>
        <button type="button"
                class="btn btn-w-m btn-primary pull-right"
                :disabled="!finalDate"
                @click="onSubmit">Choisir ces participants et cet horaire</button>
      </div>
    </div>
  </div>
</template>

<script>
  import gql from 'graphql-tag'
  import { formatDateFull } from '../../../helpers/filters/filter'

  export default {
    props: {
      command: {
        type: Object,
        required: true
      },

      seller: {
        type: Object,
        required: true
      },

      owner: {
        type: Object,
        required: true
      },

      initialSaleRdv: {
        type: Object,
        required: true
      }
    },

    data: () => ({
      saleRdvParticipant: null,
      saleRdvProposalDate: null,
      saleRdvSchedule: [],
      date: null,
      formatedDate: null,
      finalDate: null,
      comment: '',
    }),

    computed: {
      saleRdvParticipantsQuery () {
        return gql`
        {
          saleRdvParticipant(saleRdvId:"${this.initialSaleRdv.id}") {
            id,
            title,
            name
          }
        }`
      },

      saleRdvProposalDateQuery () {
        return gql`
        {
          saleRdvProposalDate(saleRdvId:"${this.initialSaleRdv.id}") {
            id,
            date
          }
        }`
      },

      addSaleRdvProposalDateMutation () {
        return gql`
        mutation {
          addSaleRdvProposalDate (saleRdvId: "${this.initialSaleRdv.id}", date: "${this.formatedDate}"){
          id
          result
          status
          }
        }`
      },

      saleRdvScheduleQuery () {
        return gql`
        {
          saleRdvSchedule(saleRdvId:"${this.initialSaleRdv.id}") {
            id
            proposalDate {
              id
            }
            participant {
              id
            }
          }
        }`
      },

      sortedSaleRdvProposalDate () {
        if (!this.saleRdvProposalDate) {
          return []
        }
        let dates = [ ...this.saleRdvProposalDate ]
        dates.sort((a, b) => {
          if (moment(a.date).isBefore(b.date)) {
            return -1
          } else if (moment(a.date).isAfter(b.date)) {
            return 1
          }
        })
        return dates
      }
    },

    watch: {
      date () {
        if (this.date) {
          this.formatedDate = moment(this.date).format('DD-MM-YYYY HH:mm:ss')
          this.addSaleRdvProposalDate()
        }
      }
    },

    mounted () {
      this.finalDate = this.initialSaleRdv.date || null
      this.comment = this.initialSaleRdv.comment || ''
      this.$bus.$on('add-participant', this.addParticipant)
    },

    destroyed () {
      this.$bus.$off('add-participant', this.addParticipant)
    },

    methods: {
      formatDateFull (date) {
        return formatDateFull(date)
      },

      onClickNewDate () {
        if (this.saleRdvProposalDate.length >= 5) {
          this.showBanner('danger', `Le nombre maximal de dates a été atteint.`)
        } else {
          document.getElementById('datetime-picker').click()
        }
      },

      onClickNewParticipant () {
        if (this.saleRdvParticipant.length > 5) {
          this.showBanner('danger', `Le nombre maximal de participants a été atteint.`)
        } else {
          this.showModal({
            childVue: 'add-participant',
            size: 'modal-md',
            dataModel: {},
          })
        }
      },

      addSaleRdvProposalDate () {
        this.$apollo.mutate({
          mutation: this.addSaleRdvProposalDateMutation
        }).then((response) => {
          const result = {
            id: response.data.addSaleRdvProposalDate.id,
            date: this.formatedDate
          }
          this.saleRdvProposalDate.push(result)
          this.date = null
          this.formatedDate = null
        })
      },

      addSaleRdvParticipantMutation (participant) {
        return gql`
         mutation {
          addSaleRdvParticipant (saleRdvId:"${this.initialSaleRdv.id}",
          name: "${participant.name}",
          title:"${participant.title}")
          {
            id
            result
            status
          }
        }`
      },

      deleteSaleRdvProposalDateMutation (id) {
        return gql`
        mutation {
          deleteSaleRdvProposalDate (saleRdvProposalDateId: "${id}"){
          id
          result
          status
          }
        }`
      },

      deleteSaleRdvProposalDate (id) {
        this.$apollo.mutate({
          mutation: this.deleteSaleRdvProposalDateMutation(id)
        }).then(() => {
          const item = this.saleRdvProposalDate.find(item => item.id === id)
          const index = this.saleRdvProposalDate.indexOf(item)
          this.saleRdvProposalDate.splice(index, 1)
        })
      },

      deleteSaleRdvParticipantMutation (id) {
        return gql`
         mutation {
          deleteSaleRdvParticipant (saleRdvParticipantId: "${id}"){
          id
          result
          status
          }
        }`
      },

      addSaleRdvScheduleMutation (participantId, dateId) {
        return gql`
        mutation {
          addSaleRdvSchedule(saleRdvId: "${this.initialSaleRdv.id}",
          saleRdvProposalDateId:"${dateId}",
          saleRdvParticipantId: "${participantId}"){
          id
          result
          status
          }
        }`
      },

      deleteSaleRdvScheduleMutation (id) {
        return gql`
        mutation {
          deleteSaleRdvSchedule (saleRdvScheduleId: "${id}"){
          id
          result
          status
          }
        }`
      },

      updateSaleRdvMutation () {
        return gql`
          mutation {
            updateSaleRdv (
            saleRdvId: "${this.initialSaleRdv.id}",
            date: "${this.finalDate}",
            comment: "${this.comment}")
            {
              id
              result
              status
            }
          }`
      },

      addParticipant (participant) {
        if (!this.saleRdvParticipant.some(item => item.title === participant.title && item.name === participant.name)) {
          this.$apollo.mutate({
            mutation: this.addSaleRdvParticipantMutation(participant)
          }).then(response => {
            const result = {
              id: response.data.addSaleRdvParticipant.id,
              title: participant.title,
              name: participant.name
            }
            if (!this.saleRdvParticipant.some(item => item.title === participant.title && item.name === participant.name)) {
              this.saleRdvParticipant.push(result)
            }
          })
        }
      },

      deleteParticipant (id) {
        this.$apollo.mutate({
          mutation: this.deleteSaleRdvParticipantMutation(id)
        }).then(() => {
          const item = this.saleRdvParticipant.find(item => item.id === id)
          const index = this.saleRdvParticipant.indexOf(item)
          this.saleRdvParticipant.splice(index, 1)
        })
      },

      availableSaleRdv (participantId, dateId) {
        return this.saleRdvSchedule.find(item => item.participant.id === participantId && item.proposalDate.id === dateId)
      },

      onChange (e, participantId, dateId) {
        if (e.target.checked) {
          this.$apollo.mutate({
            mutation: this.addSaleRdvScheduleMutation(participantId, dateId)
          }).then(response => {
            const result = {
              id: response.data.addSaleRdvSchedule.id,
              participant: {
                id: participantId
              },
              proposalDate: {
                id: dateId
              }
            }
            this.saleRdvSchedule.push(result)
          })
        } else {
          const id = this.availableSaleRdv(participantId, dateId).id
          this.$apollo.mutate({
            mutation: this.deleteSaleRdvScheduleMutation(id)
          }).then(() => {
            const item = this.saleRdvSchedule.find(item => item.id === id)
            const index = this.saleRdvSchedule.indexOf(item)
            this.saleRdvSchedule.splice(index, 1)
          })
        }
      },

      areAllSelected (dateId) {
        if (!this.saleRdvSchedule || !this.saleRdvParticipant) {
          return false
        }
        return this.saleRdvSchedule.filter(item => {
          return item.proposalDate.id === dateId
        }).length === this.saleRdvParticipant.length
      },

      onSubmit () {
        this.$apollo.mutate({
          mutation: this.updateSaleRdvMutation()
        }).then(() => {
          let newInitialSaleRdvValue = this.initialSaleRdv
          newInitialSaleRdvValue.date = this.finalDate
          newInitialSaleRdvValue.comment = this.comment
          this.$emit('update-initialSaleRdv-value', newInitialSaleRdvValue)

          this.showBanner('success', 'Les informations ont bien été modifiées.')
          this.$parent.toggleBlock(3)
        })
      }
    },

    apollo: {
      saleRdvParticipant: {
        query () {
          return this.saleRdvParticipantsQuery
        }
      },
      saleRdvProposalDate: {
        query () {
          return this.saleRdvProposalDateQuery
        }
      },
      saleRdvSchedule: {
        query () {
          return this.saleRdvScheduleQuery
        }
      },
    }
  }
</script>

<style>
  .row-flex {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display:         flex;
    justify-content: space-between;
    align-items: center;
  }
  .row-flex > [class*='col-'] {
    display: flex;
    flex-direction: column;
  }
</style>